import type {
  FindUserReservationFlightReservation,
  FindUserReservationHotelReservation,
} from "@/app/lib/types/codegen";
import { formatCurrency } from "@/app/lib/utils/currency";
import { useTranslations } from "use-intl";

type Props = {
  reservation:
    | FindUserReservationHotelReservation
    | FindUserReservationFlightReservation;
};

export const ReservationPaymentDetails = ({ reservation }: Props) => {
  const t = useTranslations();

  return (
    <section>
      <h3 className="section-title mt-4">{t("reservations.paymentDetails")}</h3>
      <ul className="section-card w-full space-y-2 text-sm">
        {reservation.externalReservation.reference.confirmation ? (
          <li className="flex w-full items-center justify-between">
            <span className="text-text-title">
              {t("reservations.orderNumber")}
            </span>
            <span className="font-semibold text-text-title">
              {reservation.externalReservation.reference.confirmation}
            </span>
          </li>
        ) : null}
        <li className="flex w-full items-center justify-between">
          <span className="text-text-title">
            {t("reservations.totalPrice")}
          </span>
          <span className="font-semibold text-text-title">
            {formatCurrency(reservation.price, reservation.currency)}
          </span>
        </li>
      </ul>
    </section>
  );
};
